"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPackagePlusOutline = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconPackagePlusOutline = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, (0, _extends2.default)({
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.158 1.026a.5.5 0 0 0-.316 0l-10.5 3.5A.5.5 0 0 0 0 5v13.5a.5.5 0 0 0 .322.467l10.5 4a.5.5 0 0 0 .356 0l2.5-.952a.5.5 0 0 0-.356-.935l-1.822.695V8.86L21 5.694V10a.5.5 0 1 0 1 0V5a.5.5 0 0 0-.342-.474l-10.5-3.5zM10.5 8.86v12.915L1 18.154V5.694l9.5 3.166zm.5-.887L2.081 5 11 2.027 19.919 5 11 7.973zM24 16.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0zm-1 0a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0zm-5 3a.5.5 0 0 0 1 0V17h2.5a.5.5 0 0 0 0-1H19v-2.5a.5.5 0 0 0-1 0V16h-2.5a.5.5 0 0 0 0 1H18v2.5z",
  fill: "#666"
}));
exports.IconPackagePlusOutline = IconPackagePlusOutline;
//# sourceMappingURL=IconPackagePlusOutline.js.map